import wixWindow from 'wix-window';

let formFactor = wixWindow.formFactor;

$w.onReady(function () {
	if (formFactor === "Mobile") {
		$w("#buttonA2").link = "https://www.youtube.com/watch?time_continue=1&v=wRAvGX7TvSs"
		$w("#buttonB2").link = "https://support.wix.com/en/article/calculating-tax-rates-with-avalara-in-wix-stores"
		$w("#buttonC2").link = "https://www.youtube.com/watch?v=wRAvGX7TvSs"
	}
});